module.exports = __webpack_public_path__ + "img/PL00187.edd09c62.png";